<template>
	<div class="animalld animalls" style="width: 75rem;margin: 0 auto;margin-top: 1.875rem;min-height: 600px;">
		<div style="display: flex;justify-content: center;margin-bottom: 16px;">
			<img style="" src="../../assets/images/cesss.png" />
		</div>
		<div style="margin-left: -70px;margin-top: -60px;margin-bottom: 10px;font-size: 16px;">
		<div style="font-weight: bold;">注意事项：</div>
		<div>1、实验室的入室项目必须为纵向的科研项目。</div>
		<div>2、申请时间必须在项目的在研时间内。</div>
		</div>
		<p style="font-size: 1.5rem;text-align: center;">动物实验中心入室申请表</p>
		<a-descriptions :column="2" layout="horizontal " bordered>
			<a-descriptions-item label="项目负责人" :span="1">
				<a-input v-model="form.ProjectLeader" placeholder="请输入项目负责人"></a-input>
			</a-descriptions-item>
			<a-descriptions-item label="学科" :span="1">
				<a-input v-model="form.Subject" placeholder="请输入学科"></a-input>
			</a-descriptions-item>
			<a-descriptions-item label="联系电话" :span="1">
				<a-input v-model="form.Tol" placeholder="请输入联系电话"></a-input>
			</a-descriptions-item>
			<a-descriptions-item label="邮箱" :span="1">
				<a-input v-model="form.Mailbox" placeholder="请输入邮箱"></a-input>
			</a-descriptions-item>
			<a-descriptions-item label="项目名称（必填）" :span="2">
				<a-select @change="changeOrders" v-model="form.EthicalReviewForTeachId" style="width:100%;"
					placeholder="请选择项目">
					<a-select-option :value="item.ethicalReviewForTeachId" v-for="item in SelIacucData">
						{{item.room}}
					</a-select-option>
				</a-select>
			</a-descriptions-item>
			<a-descriptions-item label="伦理审查编号" :span="2">
				<a-input v-model="form.AcceptanceNo" placeholder="请填写伦理审查编号"></a-input>
			</a-descriptions-item>
			<a-descriptions-item label="项目来源" :span="1">
				<a-input v-model="form.ProjectSource" placeholder="项目必须为纵向科研项目"></a-input>
			</a-descriptions-item>
			<a-descriptions-item label="项目编号" :span="1">
				<a-input v-model="form.ProjectNo" placeholder="请输入项目编号"></a-input>
			</a-descriptions-item>
			<a-descriptions-item label="动物种属" :span="1">
				<a-input v-model="form.Species" placeholder="请输入动物种属"></a-input>
			</a-descriptions-item>
			<a-descriptions-item label="申请数量" :span="1">
				<a-input v-model="form.Quantity" placeholder="请输入申请数量"></a-input>
			</a-descriptions-item>
			<a-descriptions-item label="参加实验人员" :span="2">
				<a-input v-model="form.Personnel" placeholder="请输入参加实验人员，限五人"></a-input>
			</a-descriptions-item>
			<a-descriptions-item label="计划实验时间" :span="2">
				<a-input placeholder="请输入计划实验时间" v-model="form.ExperimentTime" />
			</a-descriptions-item>
			<a-descriptions-item label="实验计划" :span="2">
				<a-textarea :autosize="true" style="margin: 16px 0;" v-model="form.Plan" placeholder="请输入实验计划"></a-textarea>
			</a-descriptions-item>
			<a-descriptions-item v-if="state==7&&$route.query.status=='详情'" label="项目负责人意见" :span="2">
				<div style="height: 100px;margin-top: 16px;">{{statetimebz1?statetimebz1:'同意'}}</div>
			</a-descriptions-item>
			<a-descriptions-item v-if="state==7&&$route.query.status=='详情'" label="审核日期" :span="1">
				<div>{{statetime1}}</div>
			</a-descriptions-item>
			<a-descriptions-item v-if="state==7&&$route.query.status=='详情'" label="签名" :span="1">
				<img :src="statetimeName1" style="width:200px;height: 100px;" />
			</a-descriptions-item>
			<a-descriptions-item v-if="state==7&&$route.query.status=='详情'" label="动物实验中心意见" :span="2">
				<div style="height: 100px;margin-top: 16px;">{{statetimebz2?statetimebz2:'同意'}}</div>
			</a-descriptions-item>
			<a-descriptions-item v-if="state==7&&$route.query.status=='详情'" label="审核日期" :span="1">
				<div>{{statetime2}}</div>
			</a-descriptions-item>
			<a-descriptions-item v-if="state==7&&$route.query.status=='详情'" label="签名" :span="1">
				<img :src="statetimeName2" style="width:200px;height: 100px;" />
			</a-descriptions-item>
			<a-descriptions-item v-if="state==7&&$route.query.status=='详情'" label="科研处意见" :span="2">
				<!-- <div style="height: 100px;margin-top: 16px;">{{statetimebz3}}</div> -->
				<img :src="statetimeName3" style="width:200px;height: 100px;" />
			</a-descriptions-item>
			<a-descriptions-item v-if="state==7&&$route.query.status=='详情'" label="审核日期" :span="1">
				<div>{{statetime3}}</div>
			</a-descriptions-item>
			<a-descriptions-item v-if="state==7&&$route.query.status=='详情'" label="签名" :span="1">
				<img :src="statetimeName3" style="width:200px;height: 100px;" />
			</a-descriptions-item>
		</a-descriptions>
		<a-row style="margin-top: 16px;" v-if="printOver">
			<a-col :span="4">
				<a-form-model-item>
					<!-- 辅助证明文件 -->
					<div style="font-size: 0.9rem;font-weight: 600;">动物实验计划书：</div>
					<div>
						<a-upload accept="application/pdf,image/*" method="post" list-type="text" name="input"
							:action="runModel=='development'?'/Flat/Fileimg':'https://wdrmapi.zkshare.com/Flat/Fileimg'"
							:file-list="fileList1" @change="handleChange1">
							<a-button>
								<a-icon type="upload" /> 点击上传
							</a-button>
						</a-upload>
					</div>
					<a @click="goToFileList1" v-if="fileList1.length>0">
						查看文件详情
					</a>
				</a-form-model-item>
		
			</a-col>
			<a-col :span="4">
				<a-form-model-item>
					<!-- 辅助证明文件 -->
					<div style="font-size: 0.9rem;font-weight: 600;">从业人员考试合格证：</div>
					<div>
						<a-upload accept="application/pdf,image/*" method="post" list-type="text" name="input"
							:action="runModel=='development'?'/Flat/Fileimg':'https://wdrmapi.zkshare.com/Flat/Fileimg'"
							:file-list="fileList2" @change="handleChange2">
							<a-button>
								<a-icon type="upload" /> 点击上传
							</a-button>
						</a-upload>
					</div>
					<a @click="goToFileList2" v-if="fileList2.length>0">
						查看文件详情
					</a>
				</a-form-model-item>
					
			</a-col>
			<a-col :span="4">
				<a-form-model-item>
					<!-- 辅助证明文件 -->
					<div style="font-size: 0.9rem;font-weight: 600;">动物室入室培训考试成绩：</div>
					<div>
						<a-upload accept="application/pdf,image/*" method="post" list-type="text" name="input"
							:action="runModel=='development'?'/Flat/Fileimg':'https://wdrmapi.zkshare.com/Flat/Fileimg'"
							:file-list="fileList3" @change="handleChange3">
							<a-button>
								<a-icon type="upload" /> 点击上传
							</a-button>
						</a-upload>
					</div>
					<a @click="goToFileList3" v-if="fileList3.length>0">
						查看文件详情
					</a>
				</a-form-model-item>
			</a-col>
		</a-row>
		<a-row v-if="printOver">
			<a-col :span="24">
				<div style="display: flex;justify-content: center;margin: 3.125rem 0;"
					v-if="this.$route.query.status!='详情'&&this.$route.query.status!='PI审核'">
					<a-button @click="onSubmit('1')" type="primary"
						style="width: 22.5rem;height: 3.75rem;margin: 0 7rem;">
						保存
					</a-button>
					<a-button @click="onSubmit('2')" type="primary"
						style="width: 22.5rem;height: 3.75rem;margin: 0 7rem;">
						提交
					</a-button>
				</div>
				<div style="display: flex;justify-content: center;margin: 8.125rem 0;"
					v-if="this.$route.query.status=='详情'">
					<a-button @click="$router.go(-1)" type="primary" style="width: 22.5rem;height: 3.75rem;">
						返回
					</a-button>
					<a-button v-if="state==7&&$route.query.status=='详情'" @click="print" type="primary"
						style="width: 22.5rem;height: 3.75rem;margin: 0 7rem;">
						导出
					</a-button>
				</div>
				<div style="display: flex;justify-content: center;margin: 2.125rem 0;"
					v-else-if="this.$route.query.status=='PI审核'">
					<a-popconfirm title="该实验是否审核通过?" ok-text="通过" cancel-text="否决"
						@confirm="PiExperimentApplication('1')" @cancel="PiExperimentApplication('2')">
						<a-button type="primary" style="width: 22.5rem;height: 3.75rem;">
							审核
						</a-button>
					</a-popconfirm>
				</div>
			</a-col>

		</a-row>
		
	</div>
</template>

<script>
	import {
		VerificationApply,
		SubmitExperimentApplication,
		SelIacuc,
		GetUserExperimentApplicationId,
		UpdateExperimentApplication,
		PiExperimentApplication,
		SelAuditRecords
	} from '@/api/index.js'
	import moment from 'moment'
	export default {
		data() {
			return {
				printOver: true,
				fileList1: [],
				fileList2: [],
				fileList3: [],
				runModel: '',
				SelIacucData: [],
				numSource: [],
				state: 777,
				statetime1: '',
				statetime2: '',
				statetime3: '',
				statetimeName1: '',
				statetimeName2: '',
				statetimeName3: '',
				statetimebz1: '',
				statetimebz2: '',
				statetimebz3: '',
				form: {
					Fj1:'',
					Fj2:'',
					Fj3:'',
					Fjjson:{},
					AcceptanceNo: '',
					Personnel: '',
					ProjectLeader: '',
					Plan: '',
					ExperimentTime: '',
					Quantity: '',
					Subject: '',
					Tol: '',
					ProjectSource: '',
					Mailbox: '',
					ProjectNo: '',
					type: '',
					Species: '',
					EthicalReviewForTeachId: undefined,
				}
			}
		},
		created() {
			this.runModel = process.env.NODE_ENV
			
			this.getVerificationApply()
			this.SelIacuc()
			if (this.$route.query.id) {
				this.GetUserExperimentApplicationId()
			}
		},
		mounted() {
			window.addEventListener('beforeprint', () => {
				console.log(this.printOver)
				document.getElementsByTagName('body')[0].style.zoom = 0.85;
				this.$parent.$children[0].$el.hidden = true
				this.$parent.$children[4].$el.hidden = true

			});

			window.addEventListener('afterprint', () => {
				document.getElementsByTagName('body')[0].style.zoom = 1;
				this.$parent.$children[0].$el.hidden = false
				this.$parent.$children[4].$el.hidden = false
				this.printOver = true
			});
		},
		methods: {
			print() {
				this.printOver = false

				setTimeout(() => {
					window.print()
				}, 100);
			},
			async SelIacuc() {
				const res = await SelIacuc({
					page: 1,
					limit: 1000
				})
				this.SelIacucData = res.data.data
			},
			async PiExperimentApplication(state) {
				const res = await PiExperimentApplication({
					ExperimentApplicationId: this.$route.query.id,
					type: state
				})
				if (res.data.state) {
					this.$message.success(res.data.info)
					this.$router.push({
						path: '/core/aniQualificationCore'
					})
				} else {
					this.$message.error(res.data.info)
				}

			},
			async GetUserExperimentApplicationId() {
				//Explainf12:this.fileList&&this.fileList.length>0?this.fileList[0].response.data.data[0].path:'',
				const res = await GetUserExperimentApplicationId({
					ExperimentApplicationsId: this.$route.query.id
				})
				
				this.form.ProjectLeader = res.data.data[0].projectLeader
				this.form.Personnel = res.data.data[0].personnel
				this.form.Plan = res.data.data[0].plan
				this.form.ExperimentTime = res.data.data[0].experimentTime
				this.form.Quantity = res.data.data[0].quantity
				this.form.Subject = res.data.data[0].subject
				this.form.Tol = res.data.data[0].tol
				this.form.ProjectSource = res.data.data[0].projectSource
				this.form.Mailbox = res.data.data[0].mailbox
				this.form.ProjectNo = res.data.data[0].projectNo
				this.form.Species = res.data.data[0].species
				this.form.EthicalReviewForTeachId = res.data.data[0].ethicalReviewForTeach.ethicalReviewForTeachId
				this.form.ExperimentApplicationId = res.data.data[0].experimentApplicationId
				this.form.AcceptanceNo = res.data.data[0].acceptanceNo
				this.state = res.data.data[0].state
				
				this.form.Fj1 = res.data.data[0].fj1
				this.form.Fj2 = res.data.data[0].fj2
				
				this.form.Fj3 = res.data.data[0].fj3
				this.fileList1 = res.data.data[0].fjjson?JSON.parse(res.data.data[0].fjjson).Fj1:[]
				this.fileList2 = res.data.data[0].fjjson?JSON.parse(res.data.data[0].fjjson).Fj2:[]
				this.fileList3 = res.data.data[0].fjjson?JSON.parse(res.data.data[0].fjjson).Fj3:[]
				
				
				if (this.state == '7' && this.$route.query.status == '详情') {
					
					this.statetime1 = res.data.data[0].statetime1
					this.statetime2 = res.data.data[0].statetime2
					this.statetime3 = res.data.data[0].statetime3
					
					this.statetimeName1 = res.data.data[0].statetimeName1
					this.statetimeName2 = res.data.data[0].statetimeName2
					
					this.statetimeName3 = res.data.data[0].statetimeName3
					this.statetimebz1 = res.data.data[0].statetimebz1
					this.statetimebz2 = res.data.data[0].statetimebz2
					this.statetimebz3 = res.data.data[0].statetimebz3
				}

			},
			onSubmit(state) {
				for (var item in this.form) {
					console.log(this.form[item])

					if (item == 'EthicalReviewForTeachId') {

						if (!this.form[item]) {
							this.$message.error('请选择项目后再提交')

							return
						}
					}
				}
				if (!this.$route.query.id) {
					
					if (state == 2) {
						if(this.fileList1.length==0||this.fileList2.length==0||this.fileList3.length==0){
							this.$message.error('请上传三个所需附件')
							return
						}
						this.form.type = state
						// this.form.ExperimentTime = moment(this.form.ExperimentTime).format('YYYY-MM-DD HH:mm:ss')
						//Explainf12:this.fileList&&this.fileList.length>0?this.fileList[0].response.data.data[0].path:'',
						this.form.Fj1 = this.fileList1&&this.fileList1.length>0?this.fileList1[0].response.data.data[0].path:''
						this.form.Fj2 = this.fileList2&&this.fileList2.length>0?this.fileList2[0].response.data.data[0].path:''
						this.form.Fj3= this.fileList3&&this.fileList3.length>0?this.fileList3[0].response.data.data[0].path:''
						this.form.Fjjson.Fj1 = this.fileList1&&this.fileList1.length>0?this.fileList1:[],
						this.form.Fjjson.Fj2 = this.fileList2&&this.fileList2.length>0?this.fileList2:[],
						this.form.Fjjson.Fj3 = this.fileList3&&this.fileList3.length>0?this.fileList3:[],
						this.form.Fjjson = JSON.stringify(this.form.Fjjson)
						this.SubmitExperimentApplication(this.form)
					}
					if (state == 1) {
						this.form.type = state
						this.form.Fj1 = this.fileList1&&this.fileList1.length>0?this.fileList1[0].response.data.data[0].path:''
						this.form.Fj2 = this.fileList2&&this.fileList2.length>0?this.fileList2[0].response.data.data[0].path:''
						this.form.Fj3= this.fileList3&&this.fileList3.length>0?this.fileList3[0].response.data.data[0].path:''
						this.form.Fjjson.Fj1 = this.fileList1&&this.fileList1.length>0?this.fileList1:[],
						this.form.Fjjson.Fj2 = this.fileList2&&this.fileList2.length>0?this.fileList2:[],
						this.form.Fjjson.Fj3 = this.fileList3&&this.fileList3.length>0?this.fileList3:[],
						// this.form.ExperimentTime = moment(this.form.ExperimentTime).format('YYYY-MM-DD HH:mm:ss')
						this.form.Fjjson = JSON.stringify(this.form.Fjjson)
						this.SubmitExperimentApplication(this.form)
					}
				} else {
					if (state == 2) {
						if(this.fileList1.length==0||this.fileList2.length==0||this.fileList3.length==0){
							this.$message.error('请上传三个所需附件')
							return
						}
						this.form.type = state
						// this.form.ExperimentTime = moment(this.form.ExperimentTime).format('YYYY-MM-DD HH:mm:ss')
						this.form.Fj1 = this.fileList1&&this.fileList1.length>0?this.fileList1[0].response.data.data[0].path:''
						this.form.Fj2 = this.fileList2&&this.fileList2.length>0?this.fileList2[0].response.data.data[0].path:''
						this.form.Fj3= this.fileList3&&this.fileList3.length>0?this.fileList3[0].response.data.data[0].path:''
						this.form.Fjjson.Fj1 = this.fileList1&&this.fileList1.length>0?this.fileList1:[],
						this.form.Fjjson.Fj2 = this.fileList2&&this.fileList2.length>0?this.fileList2:[],
						this.form.Fjjson.Fj3 = this.fileList3&&this.fileList3.length>0?this.fileList3:[],
						this.form.Fjjson = JSON.stringify(this.form.Fjjson)
						this.UpdateExperimentApplication(this.form)
					}
					if (state == 1) {
						this.form.type = state
						// this.form.ExperimentTime = moment(this.form.ExperimentTime).format('YYYY-MM-DD HH:mm:ss')
						this.form.Fj1 = this.fileList1&&this.fileList1.length>0?this.fileList1[0].response.data.data[0].path:''
						this.form.Fj2 = this.fileList2&&this.fileList2.length>0?this.fileList2[0].response.data.data[0].path:''
						this.form.Fj3= this.fileList3&&this.fileList3.length>0?this.fileList3[0].response.data.data[0].path:''
						this.form.Fjjson.Fj1 = this.fileList1&&this.fileList1.length>0?this.fileList1:[],
						this.form.Fjjson.Fj2 = this.fileList2&&this.fileList2.length>0?this.fileList2:[],
						this.form.Fjjson.Fj3 = this.fileList3&&this.fileList3.length>0?this.fileList3:[],
						this.form.Fjjson = JSON.stringify(this.form.Fjjson)
						this.UpdateExperimentApplication(this.form)
					}
				}

			},
			async SubmitExperimentApplication(data) {
				const res = await SubmitExperimentApplication(data)
				if (res.data.state) {
					if (this.form.type == 1) {
						this.$message.success("保存成功")
					} else {
						this.$message.success("提交申请成功")
					}
					this.$router.push({
						path: '/core/aniQualificationCore'
					})
				} else {
					this.$message.error(res.data.info)
				}
			},
			async UpdateExperimentApplication(data) {
				const res = await UpdateExperimentApplication(data)
				if (res.data.state) {
					if (this.form.type == 1) {
						this.$message.success("保存成功")
					} else {
						this.$message.success("修改申请成功")
					}
					this.$router.push({
						path: '/core/aniQualificationCore'
					})
				} else {
					this.$message.error(res.data.info)
				}
			},
			async getVerificationApply() {
				const res = await VerificationApply()

				if (res.data.state) {
					this.numSource = res.data.data.ealist
				}

				var that = this
				if (res.data.state == false) {
					this.$info({
						title: '请先申请福利与伦理且通过再申请实验资格',
						okText: '返回',
						onOk() {
							that.$router.go(-1)
						},
					});
				}
				
			},
			changeOrders(data) {

				this.numSource.map((n) => {

					console.log(n)
					if (n.id == data) {
						this.form.AcceptanceNo = n.acceptanceNo
					}
				})
				console.log(this.form.AcceptanceNo)
			},
			handleChange1(val) {
				console.log(val)
				// if(this.fileList.length>1){
				// 	return
				// }
				
				this.fileList1 = [val.file]
				console.log(this.fileList1)
				this.form.Fj1 = this.fileList1&&this.fileList1.length>0?this.fileList1[0].response.data.data[0].path:''
				
				
			},
			handleChange2(val) {
				console.log(val)
				// if(this.fileList.length>1){
				// 	return
				// }
				
				this.fileList2 = [val.file]
				this.form.Fj2 = this.fileList2&&this.fileList2.length>0?this.fileList2[0].response.data.data[0].path:''
				
			},
			handleChange3(val) {
				console.log(val)
				// if(this.fileList.length>1){
				// 	return
				// }
				
				this.fileList3 = [val.file]
				this.form.Fj3= this.fileList3&&this.fileList3.length>0?this.fileList3[0].response.data.data[0].path:''
			},
			onChange(date, dateString) {
				console.log(date, dateString);
			},
			goToFileList1(data){
				window.open(this.form.Fj1,'_blank')
			},
			goToFileList2(data){
				window.open(this.form.Fj2,'_blank')
			},
			goToFileList3(data){
				window.open(this.form.Fj3,'_blank')
			}
		}
	}
</script>

<style>
	/* html{
		font-size: 8px;
	} */
/* 	.animalls{
		transform: scale(0.9);
	} */
	body{
		color: black !important;
	}
	.animalls .ant-descriptions-item-label{
		background-color: transparent !important;
	}
	.animalls .ant-descriptions-row td{
		padding: 0px 24px !important;
	}
	
	.animalld .ant-descriptions-view {
		border-color: black !important;
	}

	.animalld .ant-descriptions-row td {
		border-color: black !important;
	}

	.animalld .ant-descriptions-row th {
		border-color: black !important;
	}

	.animalld .ant-descriptions-row {
		border-color: black !important;
	}

	.animalld .ant-descriptions-item-content input {
		font-size: 18px;
		/* font-weight: 600 !important; */
	}

	.animalld .ant-descriptions-item-content div {
		font-size: 18px;
		/* font-weight: 600 !important; */
	}

	.animalld .ant-descriptions-item-content textarea {
		font-size: 18px;
		/* font-weight: 600 !important; */
	}

	.animalld .ant-input {
		border-color: transparent !important;
		/* cursor: pointer; */
	}
   .animalls .ant-descriptions-item-label{
	   color: black !important;
   }
	.animalld .ant-select div {
		border-color: transparent !important;
		/* cursor: pointer; */
	}

	.animalld .ant-descriptions-item-label {
		font-size: 18px !important;
		font-weight: 500;
	}

	@page {
		/* size: portrait; */
		margin: 1cm 0.15cm 2cm 0.15cm;
	}

	/* @page {
    size: landscape;
  } */
</style>
